import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Form, Input, Row, Spin, Typography, Upload } from "antd";
import {
  DeleteOutlined,
  LoadingOutlined,
  PaperClipOutlined,
  SettingOutlined,
} from "@ant-design/icons";

const { TextArea } = Input;

const AddOfferRequest = ({ actions, state }) => {
  const { loadingSave } = state;

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [selectedFile, setSelectedFile] = useState(null);

  const addFile = (info) => {
    setSelectedFile(info.file);
  };

  const removeFile = () => {
    setSelectedFile(null);
  };

  const onFinishOffer = (values) => {
    actions.addRequest(selectedFile, values, navigate);
  };

  const getFileUrl = (file) => URL.createObjectURL(file);

  const layout = {
    labelCol: {
      sm: { span: 24 },
      md: { span: 8 },
      lg: { span: 8 },
      xl: { span: 7 },
      xxl: { span: 7 },
    },
    wrapperCol: {
      lg: { span: 14 },
      xl: { span: 12 },
    },
  };

  return (
    <>
      <div className="px-8 py-4">
        <Typography className="text-xl font-bold text-dark-blue py-1">
          KREIRANJE ZAHTJEVA ZA PONUDU ZA OSIGURANJE
        </Typography>
      </div>
      <div className="h-5 bg-login-white"></div>

      <div className="p-8">
        <Row gutter={20}>
          <Col span={24} md={20} lg={17} className="mb-12 lg:mb-0">
            <Form
              {...layout}
              colon={false}
              form={form}
              onFinish={onFinishOffer}
            >
              <Form.Item
                label="Naziv zahtjeva za ponudu"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Unesite naziv zahtjeva za ponudu",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Klijent"
                name="client"
                rules={[
                  {
                    required: true,
                    message: "Unesite naziv klijenta",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="ID broj"
                name="IDNumber"
                rules={[
                  {
                    required: true,
                    message: "Unesite ID broj",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Adresa / sjedište klijenta"
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Unesite adresu / sjedište klijenta",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Kontakt telefon"
                name="phoneNumber"
                rules={[
                  {
                    required: true,
                    message: "Unesite kontakt telefon",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Prilog"
                name="filePath"
                rules={[
                  {
                    required: true,
                    message: "Dodajte prilog",
                  },
                ]}
              >
                {!selectedFile ? (
                  <Upload
                    customRequest={addFile}
                    multiple={false}
                    maxCount={1}
                    showUploadList={false}
                    accept=".pdf"
                  >
                    <Button
                      className="rounded-sm border-inherit text-inherit "
                      icon={<SettingOutlined />}
                    >
                      Klikni da dodaš
                    </Button>
                  </Upload>
                ) : (
                  <div className="flex justify-between items-center bg-light-gray mt-2">
                    <div className="flex w-full pl-1">
                      <PaperClipOutlined />

                      <a
                        className="text-light-blue ml-2 w-4/5"
                        href={getFileUrl(selectedFile)}
                        download={selectedFile.name}
                      >
                        {selectedFile.name}
                      </a>
                    </div>
                    <DeleteOutlined
                      className="text-black opacity-40 pr-2 cursor-pointer"
                      onClick={removeFile}
                    />
                  </div>
                )}
              </Form.Item>

              <Form.Item name="note" label="Dodatne napomene">
                <TextArea rows={6} />
              </Form.Item>

              <div className="sm:flex mt-6 lg:mt-20 ml-0 md:ml-6 lg:ml-0">
                <Form.Item>
                  <Button
                    disabled={loadingSave}
                    type="primary"
                    htmlType="submit"
                    className="bg-light-blue font-medium w-full sm:w-[132px] rounded-sm mr-8 "
                  >
                    SPREMI
                  </Button>
                </Form.Item>

                {loadingSave && (
                  <Spin
                    className="w-full sm:w-fit"
                    indicator={
                      <LoadingOutlined style={{ fontSize: 32 }} spin />
                    }
                  />
                )}
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AddOfferRequest;
